import CreateSpousalSupportPaymentButton from "../../../../components/SpousalSupportPaymentButton";
import EmptyStateView from "../../../../components/EmptyStateView";
import { useSpousalSupportOrder } from "../../../../contexts/SpousalSupportOrderContext";
import { useSpousalSupportPayment } from "../../../../contexts/SpousalSupportPaymentContext";
import { Heading } from "../../../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../design/table";
import SpousalSupportPaymentListItem from "./components/SpousalSupportPaymentListItem";

const SpousalSupportPaymentsList = () => {
  const { currentSpousalSupportOrder } = useSpousalSupportOrder();
  const { spousalSupportPayments } = useSpousalSupportPayment();

  if (!currentSpousalSupportOrder) return null;

  if (spousalSupportPayments.length === 0) {
    return (
      <EmptyStateView
        title="No SpousalSupport Payments"
        message="There are no spousalSupport payments in this matter."
        action={
          <CreateSpousalSupportPaymentButton
            spousalSupportOrderId={currentSpousalSupportOrder._id}
          />
        }
      />
    );
  }

  return (
    <div>
      <div className="flex items-end justify-between gap-4">
        <Heading className="mb-4">Payments</Heading>
        <CreateSpousalSupportPaymentButton
          spousalSupportOrderId={currentSpousalSupportOrder._id}
        />
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>Date</TableHeader>
            <TableHeader>Status</TableHeader>
            <TableHeader>Amount</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {spousalSupportPayments.map((order) => (
            <SpousalSupportPaymentListItem
              key={order._id}
              spousalSupportPayment={order}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default SpousalSupportPaymentsList;
